module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_footer_image_03-7f739d79354a036988d1ac67ec28aff0.jpg";